import { render, staticRenderFns } from "./OddsOutcomeColumn.vue?vue&type=template&id=2a8c93cc"
import script from "./OddsOutcomeColumn.vue?vue&type=script&lang=ts"
export * from "./OddsOutcomeColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports